import { useEffect, useState } from 'react';
import Select from 'react-select';
import { fleetApi, logbookApi } from '../api/logbookApi';
import './NewLogbookModal.css';

const selectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: '#ffffff',
    borderColor: state.isFocused ? '#2bb344' : '#e1e8e2',
    borderRadius: 10,
    padding: '4px 2px',
    boxShadow: 'none',
    '&:hover': { borderColor: '#2bb344' },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#ffffff',
    border: '1px solid #e1e8e2',
    borderRadius: 10,
    overflow: 'hidden',
    zIndex: 9999,
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#e8f9eb'
      : state.isFocused
      ? '#f2faf3'
      : '#ffffff',
    color: '#1c241e',
    cursor: 'pointer',
    fontSize: 15,
  }),
  singleValue: (base) => ({ ...base, color: '#1c241e' }),
  input: (base) => ({ ...base, color: '#1c241e' }),
  placeholder: (base) => ({ ...base, color: '#8a958c' }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({ ...base, color: '#8a958c' }),
};

export default function NewLogbookModal({ onClose, onCreated }) {
  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fleetApi.list()
      .then(res => setVehicles(res.data))
      .catch(() => setError('Nem sikerült betölteni a járműveket.'))
      .finally(() => setLoading(false));
  }, []);

  const options = vehicles.map(v => ({
    value: v.id,
    label: v.plate_nr,
  }));

  const handleCreate = async () => {
    if (!selectedVehicle) {
      setError('Válassz egy rendszámot!');
      return;
    }
    setCreating(true);
    setError('');
    try {
      const res = await logbookApi.create(selectedVehicle.value);
      onCreated(res.data);
    } catch (err) {
      const detail = err.response?.data?.detail;
      const existingId = err.response?.data?.logbook_id;
      if (detail && existingId) {
        // Megkérdezzük, hogy átnavigáljon-e a meglévőhöz
        if (window.confirm(detail + '\n\nMegnyitod a meglévő menetlevelet?')) {
          onCreated({ id: existingId });
        }
      } else {
        setError(detail || 'Nem sikerült létrehozni a menetlevelet.');
      }
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3><i className="ti ti-clipboard-plus"></i> Új menetlevél</h3>
          <button className="modal-close" onClick={onClose}>
            <i className="ti ti-x"></i>
          </button>
        </div>

        <div className="modal-body">
          <label>Válassz rendszámot</label>
          <div className="dropdown-select-container">
            <Select
              options={options}
              value={selectedVehicle}
              onChange={setSelectedVehicle}
              isLoading={loading}
              placeholder="Keress rendszámra..."
              noOptionsMessage={() => 'Nincs találat'}
              styles={selectStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>
          {error && <p className="modal-error">{error}</p>}
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Mégse</button>
          <button className="btn-primary" onClick={handleCreate} disabled={creating}>
            {creating ? 'Létrehozás...' : 'Menetlevél nyitása'}
          </button>
        </div>
      </div>
    </div>
  );
}